<template>
  <VView class="contest-end" back-button-to="/menu" header="Sukces!">
    <!-- <VText center v-html="$t('contestEnd.content.0')" />
    <VText center small v-html="$t('contestEnd.content.1')" /> -->

    <VText center>Twój wynik został zapisany!</VText>
  </VView>
</template>

<script>
export default {
  name: 'ContestEnd',
};
</script>

<style lang="scss" scoped>
.contest-end {}
</style>
